export const DEFAULT_FRAME_TIMEOUT_MS = 30_000

export function armFrameLoadTimeout({ timeoutMs, onTimeout }) {
  let timerId = setTimeout(() => {
    timerId = null
    onTimeout()
  }, timeoutMs)

  return () => {
    if (timerId != null) {
      clearTimeout(timerId)
      timerId = null
    }
  }
}
